import { WorldpayCustomisationBorder } from './worldpay-customisation-border.interface';
import { WorldpayCustomisationInteraction } from './worldpay-customisation-interaction.interface';

export interface WorldpayCustomisationInputs {
  backgroundColor?: string;
  border?: WorldpayCustomisationBorder;
  color?: string;
  focus?: WorldpayCustomisationInteraction;
  fonts?: string[];
  hover?: WorldpayCustomisationInteraction;
  placeholder?: {
    color?: string;
  };
  validation?: {
    error?: {
      color?: string;
    };
    ok?: {
      color?: string;
    };
  };
}
